import React, { useRef, useState, useEffect, useCallback } from "react";
import { Alert } from "../UI";
import {Panel, NimbusLink as Link, useCommonTranslations} from "tds_shared_ui";
import { CartList } from "./CartList";
import "./ShoppingCart.css";
import {useUserContext} from "../../context/UserContext";

const ShoppingCartIconBase = ({
    className,
    locale
}) => {
  const node = useRef(null);
  const termsRef = useRef(null);
  const [alert, setAlert] = useState({
    display: false,
    type: "default",
    message: "",
  });

  const { user, cart, displayCart, cartQuantity, setCartDisplay } = useUserContext();
  const { translate } = useCommonTranslations();

  const togglePanel = useCallback(() => {
    if (!user) {
      setAlert({
        display: true,
        message: translate("ERROR_LOGIN_FOR_CART"),
        type: "error",
      });
    }
    setCartDisplay(!displayCart)
  }, [user, translate, setCartDisplay, displayCart]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        displayCart &&
        node.current &&
        !node.current.contains(event.target) &&
        !termsRef.current
      ) {
        setCartDisplay(false);
      }
    };
    document.addEventListener("pointerdown", handleClickOutside);
    return () => {
      document.removeEventListener("pointerdown", handleClickOutside);
    };
  }, [displayCart, setCartDisplay]);

  return (
    <div className={"cart-container " + (className || "")} ref={node}>
      {cart.length === 0 ? (
        <Link href="#" onClick={togglePanel}>
          <div>
            <i className={"fas fa-shopping-cart"}></i>
          </div>
        </Link>
      ) : (
        <Link href="#" onClick={togglePanel}>
          <div>
            <i className={"fas fa-shopping-cart"}></i>
            <span className="badge badge-danger rounded-circle">{cartQuantity}</span>
          </div>
        </Link>
      )}
      {user ? (
        <Panel floating={true} hidden={!displayCart} className="cart-panel">
          <CartList
            items={cart}
            readOnly={true}
            locale={locale}
            onShowTerms={() => termsRef.current = true}
            onHideTerms={() => {
              termsRef.current = false;
              setCartDisplay(false);
            }}
          />
        </Panel>
      ) : (
        <Panel floating={true} hidden={!displayCart} className="cart-panel">
          <div className="font-weight-bold">
            {alert.display && (
              <Alert type={alert.type} className="mt-3">
                {alert.message}
              </Alert>
            )}
          </div>
        </Panel>
      )}
    </div>
  );
};

export const ShoppingCartIcon = ShoppingCartIconBase;